// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
// JS Imports
//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../../common/helpers.mjs'
import { Discount } from '../../types/types'
// Asset Imports
// Bootstrap Imports

interface DiscountItem extends Discount {
   total: number
}

export default function DiscountList({
   discounts,
}: {
   discounts: DiscountItem[]
}) {
   const state = useQuoteContext()

   return (
      <>
         {discounts.map((obj, index: number) => (
            <div key={index} className='row'>
               <div className='col text-nowrap'>{obj.DiscountName}</div>
               <div className='col col-bhr-red text-nowrap text-end'>
                  {formatFloatAsCurrencySymbol(obj.total, state.currencyObject)}
               </div>
            </div>
         ))}
      </>
   )
}
